import styled, { css } from 'styled-components/macro';

export const Wrapper = styled('div')<any>`
  display: flex;
  align-items: center;
  align-self: center;

  @media screen and (max-width: 799px) {
    width: 100%;
    margin-top: 26px;
    justify-content: center;
    order: 3;
  }
  @media screen and (min-width: 800px) {
    margin: 1.4em 0 0 !important;
  }

  @media screen and (min-width: 1200px) {
    margin: ${({ componentName }): string =>
      componentName === 'BrowseOpus' ? '0 !important' : '1.4em 0 0 !important'};
  }

  ${({ isWithoutMargins }): string =>
    isWithoutMargins
      ? '@media screen and (min-width: 10px) {margin: 0 !important;}'
      : ''}
`;

export const Text = styled('span')<any>`
  margin: 0 13px;
  font-family: 'Proxima Nova';
  font-weight: ${({ isActive }): string => (isActive ? '700' : '600')};
  font-size: ${({ componentName }): string =>
    componentName === 'BrowseOpus' ? '0.875em' : '1em'};
  color: ${({ theme, isActive }): string =>
    isActive ? theme.AccentGreen : theme.MediumGrey};

  ${({ componentName }): any =>
    componentName === 'BrowseOpus' &&
    css`
      @media screen and (max-width: 340px) {
        margin: 0 9px;
      }
    `}
`;

export const Slider = styled('span')<any>`
  position: absolute;
  cursor: ${({ isActive }): string => (isActive ? 'pointer' : 'unset')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 60px;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  &:before {
    position: absolute;
    content: '';
    height: 10px;
    width: 10px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  background-color: ${({ theme, isActive }): string =>
    isActive ? theme.AccentGreen : theme.MediumGrey};

  ${({ isToggleSwitcher, isChecked }): any =>
    isToggleSwitcher &&
    css`
      background-color: ${({ theme }): string =>
        isChecked ? theme.AccentGreen : theme.MediumGrey};
    `}
`;

export const Checkbox = styled('input')<any>`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${Slider}:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }
`;
